<template>
  <div class="info-box">
    <div :class="'info-box__abrv ' + colorClass">
      <span>{{ title }}</span>
    </div>
    <div class="info-box__content">
      <span class="info-box__title">{{ descripcion }}</span>
      <div class="info-box__values">
        <div class="info-box__value">
          <span>{{ prefix }}</span>
          <ICountUp
            :startVal="startVal"
            :endVal="getTotal(totalVal)"
            :decimals="decimals"
            :duration="duration"
            :options="options"
          ></ICountUp>
          <span v-if="!onlyInteger">.</span>
          <span v-if="!onlyInteger && getTotalDecimals(totalVal) < 10">0</span>
          <ICountUp
            v-if="!onlyInteger"
            :startVal="startVal"
            :endVal="getTotalDecimals(totalVal)"
            :decimals="decimals"
            :duration="duration"
            :options="options"
          ></ICountUp>
        </div>
        <div v-show="enableQuantity" class="info-box__quantity">
          <span>{{ quantityText }}</span>
          <ICountUp
            :startVal="startVal"
            :endVal="parseInt(quantity)"
            :decimals="decimals"
            :duration="duration"
            :options="options"
          ></ICountUp>
        </div>
      </div>
    </div>
    <div class="info-box__button" @click="showCharts" v-show="showButton">
      <button type="button" class="btn-light btn--text">
        <i
          class="fa"
          :class="displayAnimation ? 'fa-close' : 'fa-bar-chart'"
        ></i>
      </button>
    </div>
  </div>
</template>

<script>
import ICountUp from "vue-countup-v2";
export default {
  components: {
    ICountUp
  },
  props: {
    showButton: {
      type: Boolean,
      required: false,
      default: false
    },
    displayAnimation: {
      type: Boolean,
      required: false,
      default: false
    },
    duration: {
      type: Number,
      required: false,
      default: 2.5
    },
    options: {
      type: Object,
      required: false,
      default: function() {
        return {
          useEasing: true,
          useGrouping: true,
          separator: ",",
          decimal: ".",
          prefix: "",
          suffix: ""
        };
      }
    },
    decimals: {
      type: Number,
      required: false,
      default: 0
    },
    onlyInteger: {
      type: Boolean,
      required: false,
      default: false
    },
    colorClass: {
      type: String,
      required: false,
      default: "info-box__abrv--primary"
    },
    title: {
      type: String,
      required: false,
      default: ""
    },
    descripcion: {
      type: String,
      required: false,
      default: ""
    },
    prefix: {
      type: String,
      required: false,
      default: "$"
    },
    enableQuantity: {
      type: Boolean,
      required: false,
      default: false
    },
    quantity: {
      type: Number,
      required: false,
      default: 0
    },
    quantityText: {
      type: String,
      required: false,
      default: "Cantidad"
    },
    startVal: {
      type: Number,
      required: false,
      default: 0
    },
    totalVal: {
      required: false
    }
  },
  methods: {
    getTotal(total) {
      return parseInt(
        total
          .toString()
          .split(",")
          .join("")
      );
    },
    getTotalDecimals(total) {
      return Math.abs(
        (parseFloat(
          total
            .toString()
            .split(",")
            .join("")
        ) -
          parseInt(
            total
              .toString()
              .split(",")
              .join("")
          )) *
          100
      );
    },
    showCharts() {
      this.$emit('showCharts');
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/InfoBox.vue